// Radial lines of the orbit around the Oestra jar: [x1, y1, x2, y2, opacity], inner point first
export const ORBIT_VIEW_BOX = "0 0 522 330";

export const ORBIT_LINES: readonly (readonly [number, number, number, number, number])[] = [
    [303.538, 100.103, 323.762, 69.4535, 1],
    [291.307, 104.23, 305.732, 75.5395, 1],
    [278.921, 108.721, 287.466, 82.1698, 1],
    [266.404, 113.553, 269.003, 89.314, 1],
    [253.864, 118.705, 250.507, 96.9047, 1],
    [241.376, 124.156, 232.083, 104.93, 1],
    [228.998, 129.832, 213.833, 113.316, 1],
    [216.817, 135.744, 195.865, 122.023, 1],
    [204.914, 141.819, 178.302, 130.992, 1],
    [193.362, 148.031, 161.263, 140.164, 1],
    [182.208, 154.361, 144.81, 149.492, 1],
    [171.552, 160.741, 129.099, 158.906, 1],
    [161.442, 167.147, 114.177, 168.359, 1],
    [151.946, 173.548, 100.177, 177.793, 0.982],
    [143.124, 179.887, 87.1614, 187.137, 0.945],
    [135.034, 186.13, 75.2239, 196.352, 0.906],
    [127.71, 192.243, 64.427, 205.359, 0.864],
    [121.207, 198.181, 54.8411, 214.129, 0.82],
    [115.58, 203.905, 46.5286, 222.574, 0.774],
    [110.832, 209.408, 39.5286, 230.684, 0.727],
    [107.022, 214.622, 33.9036, 238.375, 0.679],
    [104.15, 219.524, 29.677, 245.617, 0.63],
    [102.255, 224.103, 26.8723, 252.359, 0.582],
    [101.328, 228.294, 25.5129, 258.547, 0.535],
    [101.387, 232.105, 25.6067, 264.168, 0.488],
    [102.438, 235.508, 27.1453, 269.181, 0.442],
    [104.449, 238.452, 30.1242, 273.53, 0.399],
    [107.454, 240.952, 34.5401, 277.217, 0.357],
    [111.381, 242.984, 40.3385, 280.21, 0.318],
    [116.238, 244.53, 47.4996, 282.492, 0.282],
    [121.98, 245.586, 55.9843, 284.054, 0.248],
    [128.582, 246.134, 65.7256, 284.865, 0.218],
    [136.007, 246.19, 76.6687, 284.95, 0.191],
    [144.206, 245.742, 88.7587, 284.276, 0.191],
    [153.119, 244.796, 101.902, 282.888, 0.147],
    [162.69, 243.349, 116.024, 280.755, 0.131],
    [172.881, 241.417, 131.051, 277.902, 0.19],
    [183.592, 239.018, 146.856, 274.354, 0.111],
    [194.806, 236.142, 163.386, 270.121, 0.11],
    [206.407, 232.84, 180.504, 265.251, 0.11],
    [218.348, 229.114, 198.124, 259.763, 0.11],
    [230.568, 224.989, 216.143, 253.679, 0.11],
    [242.958, 220.494, 234.413, 247.045, 0.11],
    [255.464, 215.666, 252.864, 239.904, 0.11],
    [268.007, 210.506, 271.364, 232.306, 0.11],
    [280.49, 205.066, 289.782, 224.293, 0.11],
    [292.872, 199.379, 308.037, 215.895, 0.11],
    [305.052, 193.477, 326.005, 207.197, 0.11],
    [316.95, 187.398, 343.563, 198.226, 0.11],
    [328.521, 181.184, 360.62, 189.051, 0.11],
    [339.661, 174.852, 377.059, 179.72, 0.11],
    [350.333, 168.48, 392.786, 170.315, 0.11],
    [360.435, 162.066, 407.699, 160.854, 0.11],
    [369.911, 155.664, 421.68, 151.42, 0.112],
    [378.755, 149.332, 434.718, 142.083, 0.121],
    [386.849, 143.086, 446.659, 132.864, 0.134],
    [394.154, 136.973, 457.437, 123.856, 0.151],
    [400.669, 131.035, 467.035, 115.087, 0.172],
    [406.302, 125.301, 475.354, 106.632, 0.196],
    [411.044, 119.809, 482.348, 98.5332, 0.224],
    [414.857, 114.594, 487.976, 90.8403, 0.255],
    [417.732, 109.688, 492.205, 83.5946, 0.289],
    [419.615, 105.117, 494.997, 76.8604, 0.326],
    [420.544, 100.914, 496.36, 70.6611, 0.366],
    [420.49, 97.1094, 496.27, 65.0463, 0.408],
    [419.434, 93.7118, 494.727, 60.0396, 0.452],
    [417.421, 90.7609, 491.746, 55.6823, 0.498],
    [414.423, 88.2604, 487.336, 51.9947, 0.544],
    [410.487, 86.2297, 481.529, 49.0036, 0.592],
    [405.64, 84.6752, 474.379, 46.714, 0.641],
    [399.891, 83.6281, 465.886, 45.1606, 0.689],
    [393.288, 83.0724, 456.145, 44.3411, 0.737],
    [385.856, 83.0239, 445.194, 44.264, 0.783],
    [377.673, 83.4717, 433.12, 44.9371, 0.829],
    [368.754, 84.4305, 419.97, 46.3389, 0.873],
    [359.181, 85.8764, 405.846, 48.4698, 0.914],
    [348.996, 87.8003, 390.827, 51.3156, 0.953],
    [338.263, 90.1982, 374.998, 54.8619, 0.989],
    [327.066, 93.0663, 358.485, 59.0872, 1],
    [315.457, 96.3757, 341.36, 63.9647, 1],
];
